import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import ChatMessageClient from '../../ChatMessageClient';
const formatTime = () => {
    const now = new Date();
    const date = new Date(now.getTime() + 1 * 60 * 60 * 1000);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${hours}:${minutes} ${date.getHours() > 12 ? 'PM' : 'AM'}`;
};
export const TelehealthReminder = ({ consultation, message, onActionClick }) => {
    const role = $auth.role.role;
    const { t } = useTranslation();
    const attachment = message.attachments.find((el) => el.type === 'telehealth_appointment_reminder');
    if (!attachment) {
        return null;
    }
    const time = formatTime();
    const newMessage = {
        _id: 'test',
        version: 0,
        created: new Date().toISOString(),
        role_id: 0,
        modified: null,
        chat_id: consultation.chat_id,
        thread_id: null,
        content: `${t('label.telehealth_attachment_reminder_todo', { time })}`,
        // content: `${t('label.telehealth_attachment_reminder', { doctor, time })}`,
        attachments: [],
    };
    const actions = [
        {
            type: 'join-conference',
            data: { url: attachment === null || attachment === void 0 ? void 0 : attachment.conference_link },
        },
        {
            type: 'copy-conference-link',
            data: { url: attachment === null || attachment === void 0 ? void 0 : attachment.conference_link },
        },
    ];
    return (_jsx(ChatMessageClient, { role: role, message: newMessage, actions: actions, onActionClick: onActionClick, showTimestamp: false }));
};
